import axios from 'axios';
import type {
  ICheckAutomaticActivationFeeWaiveParams,
  ICheckAutomaticActivationFeeWaiveResponse,
} from '@/app-package';

const checkAutomaticActivationFeeWaive = async (
  params: ICheckAutomaticActivationFeeWaiveParams,
): Promise<ICheckAutomaticActivationFeeWaiveResponse> => {
  const { data } = await axios.get(
    `/supra_system/subscription/auto_waive_eligible/${params.userId}`,
  );
  return data;
};

export default checkAutomaticActivationFeeWaive;
